import type {
  CentinelaNumero,
  CentinelaNumerosResponse,
} from "../../../features/centinela/types";

export interface CentinelaNumeroView {
  numero: string;
  country: string | null;
  sms: boolean;
  isDefault: boolean;
}

export interface CentinelaNumerosView {
  active: CentinelaNumeroView | null;
  others: CentinelaNumeroView[];
  hasNumbers: boolean;
}

const EMPTY: CentinelaNumerosView = { active: null, others: [], hasNumbers: false };

const asText = (value: string | null | undefined): string => (value ?? "").trim();

const toView = (row: CentinelaNumero, fallback: string): CentinelaNumeroView => ({
  numero: asText(row.numero),
  country: asText(row.pais) || null,
  sms: row.sms === true,
  isDefault: asText(row.numero) === fallback,
});

export function mapCentinelaNumeros(
  payload: CentinelaNumerosResponse | undefined,
): CentinelaNumerosView {
  if (!payload) return EMPTY;

  const fallback = asText(payload.por_defecto);
  const selected = asText(payload.actual) || fallback;

  const rows = (payload.disponibles ?? [])
    .filter((row) => asText(row.numero).length > 0)
    .map((row) => toView(row, fallback));

  const active = rows.find((row) => row.numero === selected) ?? null;

  return {
    active,
    others: rows.filter((row) => row.numero !== active?.numero),
    hasNumbers: rows.length > 0,
  };
}
